import React, { Component } from "react";
import Select, { createFilter } from "react-select";
import WindowedSelect from "react-windowed-select";


const tipoPresentacion = {
  select: "SELECT",
  tabla: "TABLA"
};

const customStylesSelect = {
  control: (base) => ({
    ...base,
    height:32,
    minHeight: 32,
  }),
  valueContainer: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
}

export default class SelectComponente extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opcion: [],
      options: this.props.options
    };
  }

  componentDidMount() {
  }

  componentWillReceiveProps(newProps) {
    if(newProps.options !== this.props.options)
    this.clearValue();
  }

  getInitialState = () => ({
    //selectedOption: this.props.itemSelected,
      opcion: [],
      options: this.props.option
  }); 

  clearValue() {
    this.state.selectedOption = null;
  }
 
  handleChangeSelector = (selectedOption) => {
    if (selectedOption == null)
      this.props.selectorValue(undefined, undefined);
      else { 
        this.props.selectorValue(selectedOption.value, selectedOption);
        this.state.selectedOption = selectedOption;
      }
  };

  obtenerDatos() {
    switch (this.props.presentacion) {
      case tipoPresentacion.select:
        return (
          <div className="form-group">
            <label className="input-label-bold">{this.props.titulo} *</label>
              <WindowedSelect
                styles={customStylesSelect}
                id={this.props.idName}
                name={this.props.idName}
                //defaultValue={this.clearValue}
                onChange={this.handleChangeSelector}
                placeholder="-- seleccione --"
                options={this.props.options}
                noOptionsMessage={() => "SIN DATOS"}
                value={this.state.selectedOption}
                filterOption={createFilter({ ignoreAccents: false })}
              />
          </div>
        );
      case tipoPresentacion.tabla:
          break;
    }       
  }

  render() {
    const { selectedOption } = this.state;
    return (
      <div>
        <div className="form-group">
          {this.obtenerDatos()}
        </div>
      </div>
    );
  }
}
